import { inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Registers an SVG icon with the given name and URL.
 * IMPORTANT: This function should be called in a context where Angular's dependency injection is available.
 * This is mostly the case inside a component or service constructor.
 * @param name The name of the icon.
 * @param url The URL of the SVG file.
 */
export function registerSvgIcon(name: string, url: string) {
	const registry = inject(MatIconRegistry);
	const sanitizer = inject(DomSanitizer);
	registry.addSvgIcon(name, sanitizer.bypassSecurityTrustResourceUrl(url));
}
